import { createQueryKeys } from "@lukemorales/query-key-factory";

import { getReferralSourcesList } from "./api";

export const queries = createQueryKeys("referral-sources", {
  list: () => {
    return {
      queryKey: ["referral-sources"],
      queryFn: () => getReferralSourcesList(),
    };
  },
});
